import { CART_SOURCE } from 'constant'
import { sendServicesAndDateTime } from 'components/Appointment/actions'
import { setShoppingData, cleanShoppingData } from 'actions/shoppingData'
import { removeSkuAddedToCart } from 'components/common/hoc/withAddToQuote/actions.js'
import { rest } from 'services'
import { googleAnalyticProductRemoveFromCart, googleAnalyticProductClicks } from 'actions/googleAnalytic'
import { getGTMProductData } from 'helpers/googleAnalytic'
import { setShowCallStorePromoExpirationNotification, setShowInRangePromoExpirationNotification } from './PromotionExpirationModal/actions'
import { updateProductsCount } from 'components/common/hoc/withAddToQuote/actions'

export const removeFromCartAction = (
  commerceItemId,
  rearCommerceItemId,
  product,
  isService
) => (dispatch, getState) => {
  const { shoppingData: { _state }, storeLocatorModal: { isPilotStore }} = getState()
  const { promotionExpirationStatus: {
    showCallStorePromoExpirationNotification,
    showInRangePromoExpirationNotification
  }} = getState()
  dispatch(googleAnalyticProductRemoveFromCart({ data: getGTMProductData({ product }) }))

  return rest.api.removeFromCart({ data: { commerceItemId, rearCommerceItemId: '', isPromoExist: 'true', _state }})
    .then(shoppingData => {
      const havePromosInTheCart = (shoppingData.quotedItemAndServices && shoppingData.quotedItemAndServices.products)
        ? shoppingData.quotedItemAndServices.products.some(product => product.promotions.length > 0)
        : false

      if (isPilotStore && !isService) {
        dispatch(removeSkuAddedToCart(product.bvId))
      }
      dispatch(shoppingData.quotedItemAndServices ? setShoppingData(shoppingData) : cleanShoppingData())
      shoppingData.quotedItemAndServices
        && shoppingData.quotedItemAndServices.products
        && shoppingData.quotedItemAndServices.products.length
        && dispatch(updateProductsCount(shoppingData.quotedItemAndServices.products.length))

      shoppingData.quotedItemAndServices
        && !shoppingData.quotedItemAndServices.products
        && dispatch(updateProductsCount(0))

      if (!havePromosInTheCart
        && (showCallStorePromoExpirationNotification || showInRangePromoExpirationNotification)) {
        dispatch(setShowCallStorePromoExpirationNotification(false))
        dispatch(setShowInRangePromoExpirationNotification(false))
      }
    })
    .catch(e => {
      console.error(e)
    })
}

export const addSaveForLaterItemAction = (commerceItemId, quantity, product) => (dispatch, getState) => {
  const { shoppingData: { _state }} = getState()
  const { promotionExpirationStatus: {
    showCallStorePromoExpirationNotification,
    showInRangePromoExpirationNotification
  }} = getState()

  dispatch(googleAnalyticProductRemoveFromCart({ data: getGTMProductData({ product }) }))

  return rest.api.addSaveForLaterItem({ _state, quantity, commerceItemId })
    .then(shoppingData => {
      const havePromosInTheCart = (shoppingData.quotedItemAndServices && shoppingData.quotedItemAndServices.products)
        ? shoppingData.quotedItemAndServices.products.some(product => product.promotions.length > 0)
        : false

      dispatch(shoppingData.quotedItemAndServices ? setShoppingData(shoppingData) : cleanShoppingData())
      shoppingData.quotedItemAndServices
        && shoppingData.quotedItemAndServices.products
        && shoppingData.quotedItemAndServices.products.length
        && dispatch(updateProductsCount(shoppingData.quotedItemAndServices.products.length))

      shoppingData.quotedItemAndServices
        && !shoppingData.quotedItemAndServices.products
        && dispatch(updateProductsCount(0))

      if (!havePromosInTheCart
        && (showCallStorePromoExpirationNotification || showInRangePromoExpirationNotification)) {
        dispatch(setShowCallStorePromoExpirationNotification(false))
        dispatch(setShowInRangePromoExpirationNotification(false))
      }
    })
    .catch(e => console.error(e))
}


export const removeInactiveItemsFromCartAndContnue = () => async (dispatch, getState) => {
  const { shoppingData: { quotedItemAndServices, _state }} = getState()
  const inactiveItemIds = quotedItemAndServices.products
    .filter(product => !product.isActive)
    .map(product => product.commerceItemId)
    .join(',')

  const data = {
    commerceItemId: inactiveItemIds,
    rearCommerceItemId: '',
    isPromoExist: 'true',
    _state
  }

  const shoppingData = await rest.api.removeFromCart({ data })
  await dispatch(shoppingData.quotedItemAndServices ? setShoppingData(shoppingData) : cleanShoppingData())
  await dispatch(sendServicesAndDateTime(false))
}

export const handleProductClickAction = (product) => (dispatch) => {
  dispatch(googleAnalyticProductClicks(
    { data: getGTMProductData(product), ...CART_SOURCE }
  ))
}
